import DeliveryLocation from 'src/models/delivery-location/DeliveryLocation'
import Generic from 'src/models/generic/Generic'
import Model, { ID } from 'src/models/model'
import PagerRequestType from 'src/models/pager-request/PagerRequestType'

export default class DeliveryLocationPagerRequest extends Model {
  static name = 'DeliveryLocationPagerRequest'

  static isConfiguration = true

  static deletable = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      deliveryLocation: {
        type: DeliveryLocation,
        reference: true
      },
      pagerRequestType: {
        type: PagerRequestType,
        reference: true
      }
    }

    this.queries = {
      activePagerRequest: {
        arguments: {
          deliveryLocationName: {
            type: String,
            required: true
          },
          deliveryPosition: {
            type: String,
            required: true
          }
        },
        results: {
          value: Generic
        }
      }
    }

    this.mutations = {
      turnOffPagerRequest: {
        arguments: {
          id: {
            type: ID,
            required: true
          },
          recaptchaToken: {
            type: String,
            required: false
          }
        },
        results: {
          success: Boolean
        }
      },
      createPagerRequest: {
        arguments: {
          deliveryLocationId: {
            type: ID,
            required: true
          },
          pagerRequestTypeId: {
            type: ID,
            required: true
          },
          deliveryPosition: {
            type: String,
            required: true
          },
          recaptchaToken: {
            type: String,
            required: true
          }
        },
        results: {
          success: Boolean
        }
      }
    }
  }
}
